import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from '@peacecover/icon';

const LoadingProfileCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/fan-buddy/setting-complete', { replace: true });
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <Header />
      <div className="flex flex-col items-center justify-center gap-[17px] mt-[156px]">
        <div className="relative w-[219px] h-[219px] overflow-hidden">
          <img
            src="/assets/icons/collections/Milky Way.png"
            alt="Milky Way"
            className="object-cover w-[219px] h-[219px]"
          />
          <img
            src="/assets/backgrounds/fan-buddy/Mage Light Skin Tone.png"
            alt="Mage Light Skin Tone"
            className="w-[172px] h-[172px] absolute bottom-[3.5px] left-1/2 transform -translate-x-1/2"
          />
        </div>
        <p className="text-[20px] font-semibold text-text-main-lv1 text-center leading-[24px] whitespace-pre-line">
          {t('FanBuddySetting.loadingProfileCard')}
        </p>
      </div>
    </div>
  );
};

export default LoadingProfileCard;

const Header = () => {
  const { t } = useTranslation();
  return (
    <header className="px-[16px] py-[12px] flex items-center justify-center relative w-full">
      <button type="button" className="absolute left-[16px] top-[50%] translate-y-[-50%]">
        <ArrowLeft size={24} className="text-text-main-lv1" />
      </button>
      <p className="text-text-main-lv1 text-[17px] font-bold leading-[20px]">
        {t('FanBuddySetting.title')}
      </p>
    </header>
  );
};
